import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface ListTypeEntry {
    key: number;
    name: string;
}

interface ListTypeEntriesContextProps {
    data: Record<string, ListTypeEntry[] | null>;
    setData: (erc: string, data: ListTypeEntry[]) => void;
}

const ListTypeEntriesContext = createContext<
    ListTypeEntriesContextProps | undefined
>(undefined);

interface ListTypeEntriesProviderProps {
    children: ReactNode;
}

export const ListTypeEntriesProvider: React.FC<
    ListTypeEntriesProviderProps
> = ({ children }) => {
    const [data, setDataState] = useState<
        Record<string, ListTypeEntry[] | null>
    >({});

    const setData = (erc: string, data: ListTypeEntry[]) => {
        setDataState((prevData) => ({
            ...prevData,
            [erc]: data
        }));
    };

    return (
        <ListTypeEntriesContext.Provider value={{ data, setData }}>
            {children}
        </ListTypeEntriesContext.Provider>
    );
};

export const useERC = (): ListTypeEntriesContextProps => {
    const context = useContext(ListTypeEntriesContext);
    if (!context) {
        throw new Error('useERC must be used within a ListTypeEntriesProvider');
    }
    return context;
};
